import axios from 'axios';
import { api_url } from '../conf/conf';



// добавляю функций для админа 
export async function getPromocodes() {
    try {
        const response = await axios.post(api_url + '/getPromoCode');
        
        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        return [];
    }
}

export async function addPromocodes(count, amount){
    try {
        await axios.post(`${api_url}/addPromoCode`, { count, amount });
        console.log(`Добавлено ${count} промокодов по ${amount}`);
      } catch (error) {
        console.error("Ошибка при добавлении промокодов:", error);
      }
}

// новые функций с новой таблицей

export async function getPromoCodesAdmin() {
    try{
        const response = await axios.post(api_url + '/getPromoCodeAdmin');
        
        console.log('Response:', response.data);
        return response.data;
    }catch(error){
        console.error('Error:', error.response ? error.response.data : error.message);
        return [];
    }
}

export async function addPromoCodeAdmin(code, percent, expiresAt) {
  try {
    await axios.post(`${api_url}/addPromoCodeAdmin`, {
      code,
      percent,
      expiresAt, 
    });
    console.log(`добавлен промокод ${code} со скидкой ${percent}% до ${expiresAt}`);
  } catch (error) {
    console.error("ошибка при добавлении промокода", error);
  }
}


